type GuestChatMirrorPayload = {
  roomName: string;
  guestId: string;
  guestName: string;
  action: "joined" | "left" | "message";
  text?: string;
  sentAt?: string;
};

export async function mirrorGuestChatActivity(payload: GuestChatMirrorPayload): Promise<void> {
  try {
    await fetch("/api/meeting/guest-chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
  } catch {
    // Best-effort mirroring; in-meeting LiveKit chat still works locally.
  }
}
